import { render } from "./UtilizationStatusChart.vue?vue&type=template&id=6c2bca14&scoped=true"
import script from "./UtilizationStatusChart.vue?vue&type=script&lang=js"
export * from "./UtilizationStatusChart.vue?vue&type=script&lang=js"

import "./UtilizationStatusChart.vue?vue&type=style&index=0&id=6c2bca14&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6c2bca14"

export default script